var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import * as dd from 'dingtalk-jsapi';
import { getDingtalkConfig } from '../api/common';
var MixinDingTalk = /** @class */ (function (_super) {
    __extends(MixinDingTalk, _super);
    function MixinDingTalk() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.spaceId = '';
        return _this;
    }
    Object.defineProperty(MixinDingTalk.prototype, "isInDingTalk", {
        get: function () {
            return dd.env.platform !== 'notInDingTalk';
        },
        enumerable: false,
        configurable: true
    });
    /* methods */
    // 获取免登码
    MixinDingTalk.prototype.getFreeLoginCode = function (corpId) {
        return dd.runtime.permission.requestAuthCode({
            corpId: corpId,
        });
    };
    MixinDingTalk.prototype.initDingtalk = function () {
        var _this = this;
        var url = window.location.href;
        getDingtalkConfig({
            url: url,
        }).then(function (data) {
            _this.spaceId = data.spaceId.toString();
            dd.config(data);
            dd.error(function (err) {
                _this.$message.error('dd error: ' + JSON.stringify(err));
            });
        });
    };
    MixinDingTalk = __decorate([
        Component({
            name: 'MixinDingTalk',
        })
    ], MixinDingTalk);
    return MixinDingTalk;
}(Vue));
export default MixinDingTalk;
